import { useCallback } from 'react'

import { accountAccessShowLogin } from 'actions/UiActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useReduxStateListener from 'hooks/useReduxStateListener'
import { isLoggedIn as selectIsLoggedIn } from 'selectors/accountSelectors'

export default function usePendingLoginHandler(onLogin: () => void, mode?: App.UiAccountModalMode) {
  const isLoggedIn = useAppSelector(selectIsLoggedIn)
  const dispatch = useAppDispatch()
  const loginListener = useReduxStateListener<{ loggedIn: boolean }>(
    (state) => {
      if (selectIsLoggedIn(state)) {
        return { loggedIn: true }
      } else if (!state.ui.modal.open) {
        return { loggedIn: false }
      }
    },
  )

  const trigger = useCallback(() => {
    if (isLoggedIn) {
      onLogin()
    } else {
      loginListener.awaitResult().then(({ loggedIn }) => {
        if (loggedIn) {
          onLogin()
        }
      })
      dispatch(accountAccessShowLogin(mode))
    }
  }, [dispatch, isLoggedIn, onLogin, loginListener, mode])

  return trigger
}
